/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Heading, HFlow, VFlow } from 'bold-ui'

import { MChatRfModalButtonClose } from '../../components/MChatRfModalButtonClose'

interface ConsultaSeguimentoModalTabSelecaoProps {
  onClose: () => void
}

export function ConsultaSeguimentoModalTabSelecao(props: Readonly<ConsultaSeguimentoModalTabSelecaoProps>) {
  const { onClose } = props

  return (
    <VFlow>
      <VFlow vSpacing={2}>
        <HFlow alignItems='flex-start' justifyContent='flex-end'>
          <MChatRfModalButtonClose onClose={onClose} />
        </HFlow>
        <Heading level={1}>Entrevista de seguimento</Heading>
      </VFlow>
    </VFlow>
  )
}
